export class Tier {
  price: number;
  remaining: number;

  constructor(price: number, remaining: number) {
    this.price = price;
    this.remaining = remaining;
  }

  toJSON() {
    return {
      price: this.price,
      remaining: this.remaining
    };
  }
}
